<template>
    <div style="width: 100%;height:100%;">
        <el-dialog
                title="提示"
                :visible.sync="noRecharge"
                width="500px">
            <div class="codeText">暂时没开放提现功能，微信扫下方二维码进入{{this.$store.state.siteName}}小程序进行提现</div>
            <div class="codeImg"><img :src="this.$store.state.codeAddress"></div>
            <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="noRecharge = false">确 定</el-button>
  </span>
        </el-dialog>
        <div class="mobileBox" v-show="isShowMobile">
            <a class="close el-icon-close" @click="close" title="关闭"></a>
            <div class="mobileCon">
                <div class="mobileHeader">
                    <i class="l-icon"></i>
                </div>
                <div class="mobileMain">
                    <div class="mobileMainHeader"><img src="@/assets/images/mobile-header.png"></div>
                    <div class="mobileMainBox">
                        <div style="padding:50px 10px 10px 10px;">
                            <div class="mobileTit" v-if="mobileTit">{{mobileTit}}</div>
                            <img :src="mobileImage" class="mobile-image">
                        </div>
                    </div>
                </div>
                <div class="mobileFooter">
                    <i class="c-icon"></i>
                </div>
            </div>
        </div>
        <div class="mobileBox" v-show="isShowMobileA">
            <a class="close el-icon-close" @click="close" title="关闭"></a>
            <div class="mobileCon">
                <div class="mobileHeader">
                    <i class="l-icon"></i>
                </div>
                <div class="mobileMain">
                    <div class="mobileMainHeader"><img src="@/assets/images/mobile-header.png"></div>
                    <div class="mobileMainBox">
                        <div style="padding:50px 10px 10px 10px;">
                            <div class="mobileTit" v-if="mobileTit">{{mobileTit}}</div>
                            <div class="ql-container ql-snow" style="border:none;">
                                <div class="ql-editor">
                                    <div v-html="mobileCon"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mobileFooter">
                    <i class="c-icon"></i>
                </div>
            </div>
        </div>
        <manage-header :daren_name="daren_name" :head_img="head_img"></manage-header>
        <div class="main">
            <div class="sidebar">
                <div class="user-information">
                    <img :src="head_img" class="logo">
                    <p class="name">{{daren_name}}</p>
                    <p class="tips">手机号码：{{phone}}</p>
                    <div class="margin-top-20 flex justify-content">
                        <el-tag class="member-tags">{{occupation_name}}</el-tag>
                        <el-tag class="member-tags"  type="success" v-if="!this.$store.state.is_agent">认证达人</el-tag>
                        <el-tag class="member-tags"  type="success" v-if="this.$store.state.is_agent === 1">认证站长</el-tag>
                    </div>
                </div>
                <div class="my-balance">
                    <div class="flex align-items">
                        <img src="@/assets/images/manage-left-icon-0.png" class="icon">
                        <span class="text">我的余额</span>
                        <span class="recharge"><i @click="goToBlance">明细</i><i @click="noRecharge = true" v-if="myMoney > 0">提现</i></span>
                    </div>
                    <div class="flex align-items money-box margin-top-20">
                        <span class="money" v-if="showMoney === true">{{myMoney}}<i v-if="!myMoney">0.00</i></span>
                        <span class="money" v-if="showMoney === false">******</span>
                        <span class="icon" @click="showMoneyClick" v-if="showMoney === true"><img src="@/assets/images/manage-left-money-view-icon.png"></span>
                        <span class="icon" @click="showMoneyClick" v-if="showMoney === false"><img src="@/assets/images/manage-left-money-view-icon-1.png"></span>
                    </div>
                </div>
                <div class="left-nav-list">
                    <ul>
                        <router-link to="/daren/manage" tag="li" class="item flex align-items"><span class="icon"><img src="@/assets/images/manage-left-icon-1.png"></span><span class="text">管理首页</span></router-link>
                        <router-link to="/daren/info" tag="li" class="item flex align-items"><span class="icon"><img src="@/assets/images/manage-left-icon-2.png"></span><span class="text">达人信息</span></router-link>
                        <router-link to="/daren/order" tag="li" class="item flex align-items"><span class="icon"><img src="@/assets/images/manage-left-icon-3.png"></span><span class="text">我的订单</span></router-link>
<!--                        <router-link to="/daren/balance" tag="li" class="item flex align-items"><i class="icon el-icon-bank-card fl"></i><span class="text fl">我的余额</span></router-link>-->
<!--                        <router-link to="/daren/message" tag="li" class="item clearfix"><i class="icon el-icon-bank-card fl"></i><span class="text fl">消息中心</span></router-link>-->
                        <router-link to="/daren/agent" tag="li" class="item flex align-items" v-if="this.$store.state.is_agent === 1"><span class="icon"><img src="@/assets/images/manage-left-icon-4.png"></span><span class="text">代客下单</span></router-link>
                        <router-link to="/daren/use" tag="li" class="item flex align-items"><span class="icon"><img src="@/assets/images/manage-left-icon-5.png"></span><span class="text fl">使用指南</span></router-link>
                    </ul>
                </div>
            </div>
            <div class="manage-main">
                <transition name="el-fade-in">
                    <router-view></router-view>
                </transition>
            </div>
<!--            <div class="manage-footer">{{this.$store.state.siteName}}-企业同城推广好帮手 个人流量变现神器</div>-->
        </div>
        <back-top></back-top>
    </div>
</template>
<script>
import {myDarenInfo} from '@/config/api.js'
import ManageHeader from '@/components/ManageHeader'
import BackTop from '@/components/BackTop'
export default {
  name: 'Daren',
    provide(){
        return{
            showMobile:this.showMobile,
            showMobileA:this.showMobileA
        }
    },
    data () {
        return {
            daren_name: '',
            head_img: '',
            dialogService:false,
            showMoney:false,
            occupation_name:'',
            phone:'',
            myMoney: '',
            isShowMobile: false,
            isShowMobileA: false,
            mobileCon:'',
            mobileTit:'',
            mobileImage:'',
            propagandaTitle: '',
            noRecharge: false
        }
    },
  components: {
      ManageHeader,
      BackTop
  },
    methods: {
        getDarenInfo () {
            let data = {
                user_id: this.$store.state.user_id,
                user_type: this.$store.state.user_type,
            };
            this.$post(myDarenInfo, data)
                .then(res => {
                    let data = res.data;
                    this.daren_name = data.name;
                    this.head_img = data.head_img;
                    this.occupation_name = data.occupation_name;
                    this.phone = data.phone;
                    this.myMoney = data.money;
                })
                .catch(err => {
                    window.console.log(err)
                })
        },
        checkLogin () {
            if (!this.$store.state.code) {
                this.$router.push('/login')
            } else if (this.$store.state.user_type !== 1) {
                this.$router.push('/');
                this.$message.error('很抱歉，您不是达人用户，请注册认证！');
            } else if (this.$store.state.user_type === 1 && this.$store.state.is_auth !== 1 && this.$store.state.newbie_task !== 1) {
                this.$router.push('/');
                this.$message.error('很抱歉，您还不是认证达人，请认证！')
            }
        },
        showMoneyClick () {
            this.showMoney = !this.showMoney
        },
        showMobile () {
            this.isShowMobile = true;
        },
        showMobileA () {
            this.isShowMobileA = true;
        },
        close () {
            this.isShowMobile = false;
            this.isShowMobileA = false;
        },
        goToBlance () {
            this.$router.push('/daren/balance')
        }
    },
    computed: {
        mobileContent() {
            return this.$store.state.mobileCon;
        },
        mobileImageCon () {
            return this.$store.state.previewImage;
        },
        mobileTitle() {
            return this.$store.state.mobileTit;
        }
    },
    watch: {
        mobileContent (newCount) {
            this.mobileCon = newCount;
        },
        mobileImageCon (newCount) {
            this.mobileImage = newCount;
        },
        mobileTitle (newCount) {
            this.mobileTit = newCount;
        },
        // "$route": "getNews"
    },
    mounted() {
      this.getDarenInfo();
      this.checkLogin();
    }
}
</script>
<style scoped>
    .router-link-active{background: #f7f7f7;color:#FE9539}
    .codeImg{text-align: center;width:100%;}
    .codeText{text-align: center;margin-bottom: 20px;}
    .codeImg img{width:180px;}
</style>
